import React, { useState } from "react";
import styles from "./CartPaymentPage.module.css";
import { useHistory } from "react-router-dom";

import { useCart, getCartItemCount } from "../../hooks/useCart";
import Navbar from "components/Navbar";
import BottomNav from "components/BottomNav";
import Button from "Shared/Button";
import CardList from "components/CardList";
import { useTranslation } from "react-i18next";
import { usePaymentMethods } from "../../hooks/usePaymentMethods";

export function CartPaymentPage() {
  const { t } = useTranslation();
  const history = useHistory();
  const [, setActiveTab] = useState("Cart");

  const { data: cardList = [] } = usePaymentMethods();

  const handleTabClick = (item) => {
    setActiveTab(item.label);
    history.push(item.href);
  };

  const menuItems = [
    { label: "WWG Store", href: "/wwg-store" },
    { label: "My Lists", href: "/my-lists" },
    { label: "Digital Delivery", href: "/digital-delivery" },
    { label: "Cart", href: "/cart" },
  ];

  const { data: cartData } = useCart();
  const cartCount = getCartItemCount(cartData);

  return (
    <div className={styles.container}>
      {/* Desktop-only top nav */}
      <div className={styles.desktopNav}>
        <Navbar
          onClick={() => history.push(`/cart`)}
          isHome={false}
          menuItems={menuItems}
          activeTab={t("Cart")}
          onTabClick={handleTabClick}
          cartCount={cartCount}
        />
      </div>

      <div className={styles.button}>
        <Button
          text={t("Add Card")}
          className="closeBtn"
          onClick={() => alert("Add Card Clicked!")}
        />
      </div>

      <div className={styles.separator} />

      <CardList
        cardList={cardList}
        onSelectCard={() => console.log("Card Item Clicked!")}
      />

      {/* Mobile-only bottom nav */}
      <BottomNav cartCount={cartCount} />
    </div>
  );
}

export default CartPaymentPage;
